import { render, staticRenderFns } from "./mylike.vue?vue&type=template&id=360de727&scoped=true&"
import script from "./mylike.vue?vue&type=script&lang=js&"
export * from "./mylike.vue?vue&type=script&lang=js&"
import style0 from "./mylike.vue?vue&type=style&index=0&id=360de727&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360de727",
  null
  
)

export default component.exports